function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.function.bind.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import shallowDiffers from "../../util/shallowDiffers";
import pick from "../../util/pick";
var withPropsOnChangeDebounce = function withPropsOnChangeDebounce(milisseconds, shouldMapOrKeys, propMap // eslint-disable-line @typescript-eslint/no-explicit-any
) {
  var timer = null;
  var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
    return shallowDiffers(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
  };
  return function (Component) {
    var WithPropsOnChangeDebounce = /*#__PURE__*/function (_React$Component) {
      _inherits(WithPropsOnChangeDebounce, _React$Component);
      var _super = _createSuper(WithPropsOnChangeDebounce);
      function WithPropsOnChangeDebounce(props) {
        var _this;
        _classCallCheck(this, WithPropsOnChangeDebounce);
        _this = _super.call(this, props);
        _this.state = {};
        _this.updateState = _this.updateState.bind(_assertThisInitialized(_this));
        return _this;
      }

      // eslint-disable-next-line react/no-deprecated
      _createClass(WithPropsOnChangeDebounce, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          var _this2 = this;
          if (shouldMap(this.props, nextProps)) {
            var currentProps = this.props;
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              timer = null;
              _this2.updateState(currentProps, nextProps);
            }, milisseconds);
          }
        }
      }, {
        key: "updateState",
        value: function updateState(oldProps, nextProps) {
          var nextState = propMap(nextProps, oldProps);
          this.setState(nextState);
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(Component, _extends({}, this.props, this.state));
        }
      }]);
      return WithPropsOnChangeDebounce;
    }(React.Component);
    if (process.env.NODE_ENV !== 'production') {
      var componentName = Component.displayName || Component.name || 'Component';
      // @ts-expect-error TODO
      WithPropsOnChangeDebounce.displayName = "WithPropsOnChangeDebounce(".concat(componentName, ")");
    }
    hoistNonReactStatics(WithPropsOnChangeDebounce, Component);
    return WithPropsOnChangeDebounce;
  };
};
export default withPropsOnChangeDebounce;